export class UserConfirmationRequestModel {
  constructor(
    public registrationKey: string,
    public verificationCode: string,
    public password?: string,
    public generateTemporaryPassword?: boolean,
    public url?: string
  ) {
  }
}


